export enum LocationMenuDialogs {
  ADD_ADDRESS = "addAddress",
  ADD_NOTES = "addNotes",
  EDIT_ADDRESS = "editAddress",
  EDIT_CONTACT = "editContact",
  EDIT_NOTES = "editNotes",
  EDIT_ACCOUNT_MANAGER = "editAccountManager",
  EDIT_SALES_PERSON = "editSalesPerson",
}

export enum LocationConfirmationDialogs {
  CANCEL = "cancel",
  SUCCESS = "success",
}

export type LocationDialogType = LocationMenuDialogs | LocationConfirmationDialogs | null
